import React from 'react';
import Main from '../Main';
import './index.css';

class App extends React.Component {
  render() {
    return (
      <div className='App-container'>
        <Main />
      </div>
    );
  }
}

export default App;
